/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'CarRentalType'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('carrentaltype'); // main translation loaded for carrentaltype
		$translatePartialLoader.addPart('car'); // one to many reference from main entity

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/carrentaltype/carrentaltype-dialog.html';

		return {
			/* new state for entity carRentalType */
			/* to access: ui-ref="carrentaltype.list.new" */
			/* url: hostname/carrentaltype/new */
			url: url,
			data: {
				authorities: ['ROLE_USER'],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				referredBy: null, // will be populated once this new state is triggered from another new state with + button
				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				'HistoryService',
				function($stateParams, $state, $uibModal, $rootScope, HistoryService) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'CarRentalTypeDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'CarRentalTypeFactory',
									'NewCarRentalTypeFactory',
									function(CarRentalTypeFactory, NewCarRentalTypeFactory) {
										if (isEditMode) {
											// get the entity by its ID
											return CarRentalTypeFactory.get({ id: $stateParams.carRentalTypeId }).$promise.then(
												function(data) {
													return data;
												},
												function(error) {
													return error;
												}
											);
										} else {
											// get a new empty entity
											return NewCarRentalTypeFactory.get().$promise.then(
												function(data) {
													return data;
												},
												function(error) {
													return error;
												}
											);
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function(result) {
							// process success result, if necessary
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// set relation as reference in the referredBy data model
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = result;
							}
						})
						.catch(function(closeReason) {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// reset relation in referred data model object
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = null;
							}
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								HistoryService.updateHistoryParamsData($stateParams.referredBy.data, $stateParams.referredBy.refName);
							}

							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for carRentalType new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for carRentalType edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('carrentaltype', {
		/* abstract state for entity carRentalType */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/carrentaltype',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'CarRentalTypes',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('carrentaltype.list', {
		/* list state for entity carRentalType */
		/* to access: ui-ref="carrentaltype.list" */
		/* url: hostname/carrentaltype/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/carrentaltype/carrentaltypes.html',
				controller: 'CarRentalTypeController',
			},
		},
	});

	$stateProvider.state('carrentaltype.detail', {
		/* detail state for entity carRentalType */
		/* to access: ui-sref="carrentaltype.detail" */
		/* url: hostname/carrentaltype/detail/:carRentalTypeId */
		url: '/detail/:carRentalTypeId',
		views: {
			'content@': {
				templateUrl: 'app/entities/carrentaltype/carrentaltype-detail.html',
				controller: 'CarRentalTypeDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'CarRentalTypeFactory',
				function($stateParams, CarRentalTypeFactory) {
					return CarRentalTypeFactory.get({ id: $stateParams.carRentalTypeId });
				},
			],
		},
	});

	/* url: http://<hostname>/carrentaltype/list/new */
	$stateProvider.state('carrentaltype.list.new', getNewState());
	/* url: http://<hostname>/carrentaltype/list/:carRentalTypeId/edit */
	$stateProvider.state('carrentaltype.list.edit', getEditState('/:carRentalTypeId/edit'));
	/* url: http://<hostname>/carrentaltype/detail/:carRentalTypeId/edit */
	$stateProvider.state('carrentaltype.detail.edit', getEditState('/edit'));
});
